import { CONTENTFUL_SPACE_ID } from 'bl_admin/shared/constants'

import { blAdminGenericProductPath } from 'lib/urls'

export { blAdminGenericProductPath }
export const blAdminPath = '/bl_admin'
export const blAdminApiPath = `${blAdminPath}/api`
export const blAdminApiAddNextLookupPath = `${blAdminApiPath}/product_recommendations/add_next_lookup`
export const blAdminApiBrandsPath = `${blAdminApiPath}/brands`
export const blAdminApiBrandPath = (id) => `${blAdminApiBrandsPath}/${id}`
export const blAdminCatalogCategoriesPath = `${blAdminPath}/catalog_categories`
export const blAdminCatalogCategoriesDownloadPath = (catalogCategoryId) =>
  catalogCategoryId
    ? `${blAdminCatalogCategoriesPath}_download/${catalogCategoryId}`
    : `${blAdminCatalogCategoriesPath}_download`
export const blAdminApiCatalogCategoriesPath = `${blAdminApiPath}/catalog_categories`
export const blAdminApiCatalogCategoryPath = (id) =>
  `${blAdminApiCatalogCategoriesPath}/${id}`
export const blAdminApiCatalogCategoryParentsPath = `${blAdminApiPath}/catalog_category_parents`
export const blAdminApiCatalogCategoryParentPath = (id) =>
  `${blAdminApiCatalogCategoryParentsPath}/${id}`
export const blAdminApiChildCatalogCategoryParentsPath = (id) =>
  `${blAdminApiCatalogCategoryPath(id)}/child_catalog_category_parents`
export const blAdminApiOrphanedCatalogCategoriesPath = `${blAdminApiCatalogCategoriesPath}/orphaned_categories`
export const blAdminApiRebuildCategoryGraphPath = `${blAdminApiCatalogCategoriesPath}/rebuild_category_graph`
export const blAdminApiContentSyncPath = `${blAdminApiPath}/content_sync`
export const blAdminApiEmailPreviewPath = (id, litmus, series) =>
  `${blAdminApiPath}/emails/${id}/preview?litmus=${litmus}&series=${series}`
export const blAdminApiGenericProductPath = (id) =>
  `${blAdminApiGenericProductsPath}/${id}`
export const blAdminApiGenericProductsPath = `${blAdminApiPath}/generic_products`
export const blAdminApiGenericProductsSearchPath = `${blAdminApiGenericProductsPath}/search`
export const blAdminApiInsuranceImportJobs = `${blAdminApiPath}/insurance_import_jobs`
export const blAdminApiInsuranceImportJobPreview = `${blAdminApiPath}/insurance_import_jobs/preview`
export const blAdminApiInsuranceImportJobImport = `${blAdminApiPath}/insurance_import_jobs/import`
export const blAdminApiInsuranceDashboard = `${blAdminApiPath}/dme_insurance_dashboard`
export const blAdminApiInsuranceProductsDashboard = `${blAdminApiPath}/dme_insurance_products_dashboard`
export const blAdminApiDmeOrdersDashboard = `${blAdminApiPath}/dme_orders_dashboard`
export const blAdminApiDmeOrdersDashboardExport = `${blAdminApiPath}/dme_orders_dashboard/export`
export const blAdminApiInsuranceExport = `${blAdminApiPath}/insurance_import_jobs/export`
export const blAdminNetSuiteSyncingJobsPath = `${blAdminPath}/net_suite_syncing_jobs`
export const blAdminNetSuiteSyncingJobsDownloadPath = `${blAdminNetSuiteSyncingJobsPath}/download`
export const blAdminNetSuiteSyncingJobDownloadPath = (job_id) =>
  `${blAdminNetSuiteSyncingJobsPath}/${job_id}/download_job`
export const blAdminNetSuiteSyncingJobsDownloadReportPath = (reportId) =>
  `${blAdminNetSuiteSyncingJobsPath}/download_report?report_id=${reportId}`
export const blAdminApiNetSuiteSyncingJobsPath = `${blAdminApiPath}/net_suite_syncing_jobs`
export const blAdminApiNetSuiteSyncingJobPath = (id) =>
  `${blAdminApiNetSuiteSyncingJobsPath}/${id}`
export const blAdminApiNetSuiteSyncingJobsBulkActionPath = `${blAdminApiNetSuiteSyncingJobsPath}/bulk_action`
export const blAdminApiPurchaseOrderSyncsPath = `${blAdminApiPath}/purchase_order_syncs`
export const blAdminApiProductImportJobsPath = `${blAdminApiPath}/product_import_jobs`
export const blAdminApiProductImportJobPath = (id) =>
  `${blAdminApiProductImportJobsPath}/${id}`
export const blAdminApiProductMovePath = (id) =>
  `${blAdminApiSingleProductsPath}/${id}/move`
export const blAdminApiProductResetCreatedAtPath = (id) =>
  `${blAdminApiSingleProductsPath}/${id}/reset_created_at`
export const blAdminApiProductUpdateBundleComponentsPath = (id) =>
  `${blAdminApiSingleProductsPath}/${id}/bundle_components`
export const blAdminApiProductOffersPath = `${blAdminApiPath}/product_offers`
export const blAdminApiRegItemsMigrationPath = `${blAdminApiPath}/reg_items_migrations`
export const blAdminApiRegItemsMigrationPreviewPath = `${blAdminApiRegItemsMigrationPath}/preview`
export const blAdminApiSalesPath = `${blAdminApiPath}/sales`
export const blAdminApiSaleBulkActionPath = `${blAdminApiPath}/sales/bulk_action`
export const blAdminApiSalePath = (id) => `${blAdminApiSalesPath}/${id}`
export const blAdminApiSingleProductPath = (id) =>
  `${blAdminApiSingleProductsPath}/${id}`
export const blAdminApiSingleProductsPath = `${blAdminApiPath}/products`
export const blAdminApiSingleProductBackfillOffersPath = (productId) =>
  `${blAdminApiSingleProductPath(productId)}/backfill_offers`
export const blAdminApiSingleProductSearchPath = `${blAdminApiSingleProductsPath}/single_product_search`
export const blAdminApiReturnsPath = `${blAdminApiPath}/returns`
export const blAdminApiTagsPath = `${blAdminApiPath}/tags`
export const blAdminApiUserReviewsPath = `${blAdminApiPath}/user_reviews`
export const blAdminBackfillProductOfferPath = (productOfferId) =>
  `${blAdminCatalogProductOffersPath}/${productOfferId}/backfill`
export const blAdminCatalogGenericProductsPath = `${blAdminPath}/catalog/generic_products`
export const blAdminCatalogImageableImagesPath = `${blAdminPath}/catalog/imageable_images`
export const blAdminCatalogProductOffersPath = `${blAdminPath}/catalog/product_offers`
export const blAdminCatalogProductOfferPath = (id) =>
  `${blAdminCatalogProductOffersPath}/${id}`
export const blAdminCommentsPath = `${blAdminApiPath}/comments`
export const blAdminCommentPath = (id) => `${blAdminCommentsPath}/${id || ''}`
export const blAdminEmailPath = ({ id, series }) =>
  `${blAdminPath}/emails/${id}?series=${series}`
export const blAdminGenericProductsPath = `${blAdminPath}/generic_products`
export const blAdminInsuranceImportJobsDownload = `${blAdminPath}/insurance_import_jobs/download`
export const blAdminNewProductPath = `${blAdminPath}/products/new`
export const blAdminNewSingleProductPath = `${blAdminPath}/products/single/new`
export const blAdminProductImportJobsPath = `${blAdminPath}/product_import_jobs`
export const blAdminProductImportJobPath = (id) =>
  `${blAdminProductImportJobsPath}/${id}`
export const blAdminProductImportJobCSVPath = (id) =>
  `${blAdminProductImportJobsPath}/${id}.csv`
export const blAdminProductOffersPath = (id) =>
  `${blAdminProductsPath}/${id}/offers`
export const blAdminProductPath = (genericProductId, productId) =>
  `${blAdminGenericProductPath(genericProductId)}/${productId}`
export const blAdminProductsPath = `${blAdminPath}/products`
export const blAdminProductVolumePath = (gtin) =>
  `${blAdminPath}/products/${gtin}/volume.json`
export const blAdminSalePath = `${blAdminPath}/sales`
export const blAdminSaleDownloadPath = ({ type, state }) =>
  `${blAdminSalePath}/download/?sale_type=${type}&state=${state}`
export const contentfulEntryPath = (sysId) =>
  `https://app.contentful.com/spaces/${CONTENTFUL_SPACE_ID}/entries/${sysId}`
export const blAdminInvoiceImportPath = `${blAdminApiPath}/invoice_import`
export const genericProductsPath = '/gp'
export const vendorItemSetupTemplatesUrl =
  'https://rose-fly-2050.notion.site/Item-Setup-f35b7f8250654dc3a0fb39d80fc5290b'
